module.exports = __webpack_public_path__ + "img/accountingaccount_pappers.c7c161dc.png";